/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Grid, TextInput, RadioButton, Dropdown, Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import { v4 } from 'uuid';
import CustomPeopleInTheOtherVehiclesSettings from './CustomPeopleInTheOtherVehicles.settingsForm';
import './CustomPeopleInTheOtherVehicles.scss';
import FileUpload from '../utils/FileUpload/FileUpload';
import Autocomplete from '../utils/Autocomplete/Autocomplete';
import AutocompleteDMTI from '../utils/AutocompleteDMTI/AutocompleteDMTI';
import { getTypelist, peopleInTpVehicleOptions, applyThirdPartyOptions, insurerArray, issuingProvince } from './ComponentsOptions';
import FatalityPopUp from '../../../components/FatalityPopup/FatalityPopUp';
import getLocalParams from '../localizationCustoms';
import messages from '../utils/FileUpload/messages';
import FormioErrorHandler from '../../../components/FormioErrorHandler/FormioErrorPopup';

const CustomPeopleInTheOtherVehicles = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      data: props.data,
      openEnterManuallyForm: { 0: false },
      fatalityModal: { opened: false, num: 0 },
      formErrors: props.formErrors,
      hasTriggeredError: false,
      errorPhoneNumberStart1: false,
    };
    this.errorHandler = this.errorHandler.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.dragAndDropHandler = this.dragAndDropHandler.bind(this);
    this.removeEnterManuallyFields = this.removeEnterManuallyFields.bind(this);
    this.addEnterManuallyFields = this.addEnterManuallyFields.bind(this);
    this.checkedRadioButton = this.checkedRadioButton.bind(this);
    this.dynamicLabels = this.dynamicLabels.bind(this);
    this.getClaimType = this.getClaimType.bind(this);
    this.checkIfProvinceQuebec = this.checkIfProvinceQuebec.bind(this);
    this.addNewElement = this.addNewElement.bind(this);
    this.removeNewElement = this.removeNewElement.bind(this);
    this.isABOnly = this.isABOnly.bind(this);
  }

  componentDidMount() {
    const { state: { value }, props: { onChange, form } } = this;
    form?.on('error', this.errorHandler);
    if (this.getClaimType() === 'multi_vehicle' && !this.isABOnly() && !applyThirdPartyOptions.some((e) => e.value === 'unconsciousInTheirVehicle')) {
      applyThirdPartyOptions.splice(applyThirdPartyOptions.length - 1, 0, { label: 'Unconscious in their vehicle', value: 'unconsciousInTheirVehicle' });
    }
    if (typeof value === 'undefined' || value === null || value?.peopleInTheOtherVehiclesInfo.length === 0) {
      const newObject = { temporaryId: `tempId-${v4()}`, id: '', vehicleIncidentTempId: `vehicle-incident-tempId-${v4()}`, vehicleIncidentId: '', injuryIncidentTemporaryId: `injury-incident-tempId-${v4()}`, injuryIncidentId: '', firstName: { value: '', review: { label: this.getNameReviewLabel(), defaultValue: 'Unknown' } }, lastName: { value: '', review: { label: this.getNameReviewLabel() } }, number: { value: '', review: { label: 'Contact', defaultValue: 'Unknown' } }, file_TPinfo: {} };
      if (this.getClaimType() === 'multi_vehicle' && !this.isABOnly()) {
        newObject.peopleInTpVehicle = { value: '', review: { label: 'Number of passengers', defaultValue: 'Unknown', typelist: getTypelist('peopleInTpVehicle', this.getClaimType()) } };
        newObject.insuranceInfo = { insurer: '', policyNumber: '' };
      }
      if (this.checkIfProvinceQuebec() && !this.isABOnly()) {
        newObject.applyThirdParty = { value: '', review: { label: 'Injuries', typelist: getTypelist('applyThirdParty', this.getClaimType()) } };
      }
      if (this.isABOnly() && this.getClaimType() === 'occupantThirdPartyVehicle') {
        delete newObject.id;
        delete newObject.temporaryId;
        delete newObject.injuryIncidentTemporaryId;
        delete newObject.injuryIncidentId;
        delete newObject.vehicleIncidentId;
        delete newObject.vehicleIncidentTempId;
        newObject.noteId = '';
        newObject.noteTemporaryId = `tempId-${v4()}`;
        newObject.insuranceInfo = { insurer: '', policyNumber: '' };
      } else if (this.isABOnly() && this.getClaimType() === 'injuredPedestrianOrCyclist') {
        newObject.vehicle = { insurer: '', policyNumber: '', make: '', model: '', year: '' };
      }
      this.setState({ value: { peopleInTheOtherVehiclesInfo: [newObject] }, formErrors: [{ applyThirdParty: false, number: false }] }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    } else {
      const tempState = { ...value };
      const tempOpenEnterManuallyForm = {};
      const errors = [];
      tempState.peopleInTheOtherVehiclesInfo.forEach((element, index) => {
        errors.push({ applyThirdParty: false, number: false });
        if (!this.isABOnly()) {
          if (element.insuranceInfo?.issuingProvince || element.insuranceInfo?.licenseNumber) {
            tempOpenEnterManuallyForm[index] = true;
          } else {
            tempOpenEnterManuallyForm[index] = false;
          }
        } else if (this.isABOnly() && (this.getClaimType() === 'occupantThirdPartyVehicle' || this.getClaimType() === 'injuredPedestrianOrCyclist')) {
          if (element.license) {
            tempOpenEnterManuallyForm[index] = true;
          } else {
            tempOpenEnterManuallyForm[index] = false;
          }
        }
      });
      this.setState({
        value,
        openEnterManuallyForm: tempOpenEnterManuallyForm,
        formErrors: errors,
      }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    }
  }

  handleChange(inputValue, index, name) {
    const { state: { value, formErrors, hasTriggeredError, fatalityModal }, props: { onChange } } = this;
    const errors = formErrors?.length ? [...formErrors] : [];
    const tempFatality = { ...fatalityModal };
    if ((name === 'insurer' || name === 'policyNumber' || name === 'issuingProvince' || name === 'licenseNumber') && !this.isABOnly()) {
      const newList = [...value.peopleInTheOtherVehiclesInfo];
      if (this.getClaimType() === 'multi_vehicle') {
        newList[index].insuranceInfo[name] = inputValue;
      } else {
        newList[index].license[name] = inputValue;
      }
      this.setState({
        value: {
          peopleInTheOtherVehiclesInfo: newList,
        },
      }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    } else if ((name === 'issuingProvince' || name === 'licenseNumber') && this.isABOnly()) {
      const newList = [...value.peopleInTheOtherVehiclesInfo];
      newList[index].license[name] = inputValue;
      this.setState({
        value: {
          peopleInTheOtherVehiclesInfo: newList,
        },
      }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    } else if ((name === 'insurer' || name === 'policyNumber' || name === 'make' || name === 'model' || name === 'year') && this.isABOnly()) {
      const newList = [...value.peopleInTheOtherVehiclesInfo];
      if (this.getClaimType() === 'occupantThirdPartyVehicle') {
        newList[index].insuranceInfo[name] = inputValue;
      } else {
        newList[index].vehicle[name] = inputValue;
      }
      this.setState({
        value: {
          peopleInTheOtherVehiclesInfo: newList,
        },
      }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    } else {
      const newList = [...value.peopleInTheOtherVehiclesInfo];
      if (name === 'firstName' || name === 'lastName') {
        newList[index][name] = { value: inputValue, review: { label: this.getNameReviewLabel(), defaultValue: name === 'firstName' ? 'Unknown' : null } };
      } else if (name === 'number') {
        newList[index][name] = { value: inputValue, review: { label: 'Contact', defaultValue: 'Unknown' } };
        errors[index][name] = !this.isPhoneNumberValid(inputValue) && hasTriggeredError;
      } else if (name === 'address') {
        newList[index][name] = { value: inputValue.value, addressObj: inputValue.addressObj, review: { label: 'Contact', value: inputValue.value } };
      } else if (name === 'peopleInTpVehicle') {
        newList[index][name] = { value: inputValue, review: { label: 'Number of passengers', typelist: getTypelist('peopleInTpVehicle', this.getClaimType()), defaultValue: 'Unknown' } };
      } else if (name === 'applyThirdParty') {
        if (inputValue === 'lossOfLife') {
          tempFatality.num = fatalityModal.num + 1;
        } else {
          tempFatality.num = fatalityModal.num > 0 ? fatalityModal.num - 1 : 0;
          tempFatality.opened = tempFatality.num > 0;
        }
        errors[index][name] = hasTriggeredError && !inputValue;
        newList[index][name] = { value: inputValue, review: { label: 'Injuries', typelist: getTypelist('applyThirdParty', this.getClaimType()) } };
        this.setState({
          value: {
            peopleInTheOtherVehiclesInfo: newList,
          },
          formErrors: errors,
          fatalityModal: tempFatality,
        }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      } else {
        newList[index][name] = { value: inputValue };
      }
      this.setState({
        value: {
          peopleInTheOtherVehiclesInfo: newList,
        },
        formErrors: errors,
      }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    }
  }

  getNameReviewLabel() {
    switch (this.getClaimType()) {
      case 'collisionWithCyclist':
        return 'Cyclist';
      case 'collisionWithPedestrian':
        return 'Pedestrian';
      default:
        return 'Driver';
    }
  }

  getClaimType() {
    const { data } = this.state;
    if (data.lossCause?.value === 'multi_vehicle') {
      return 'multi_vehicle';
    }
    if (data.lossCause?.value === 'single_vehicle' && data.secLossCause_single_vehicle?.value === 'collisionWithCyclist') {
      return 'collisionWithCyclist';
    }
    if (data.lossCause?.value === 'single_vehicle' && data.secLossCause_single_vehicle?.value === 'collisionWithPedestrian') {
      return 'collisionWithPedestrian';
    }
    if (data.lossCause?.value === 'occupantThirdPartyVehicle') {
      return 'occupantThirdPartyVehicle';
    }
    if (data.lossCause?.value === 'injuredPedestrianOrCyclist') {
      return 'injuredPedestrianOrCyclist';
    }
    return 'undefined';
  }

  errorHandler = () => {
    const { value } = this.state;
    const { peopleInTheOtherVehiclesInfo } = value;
    const errors = [];
    peopleInTheOtherVehiclesInfo.forEach((element) => {
      const applyThirdParty = !element?.applyThirdParty?.value;
      const number = element?.number ? !this.isPhoneNumberValid(element.number.value) : false;
      const file_TPinfo = element.file_TPinfo.rejectedFiles?.length;
      errors.push({ applyThirdParty, number, file_TPinfo });
    });
    this.setState({ hasTriggeredError: true, formErrors: errors });
  };

  checkIfProvinceQuebec = () => {
    const { data } = this.state;
    const thePolicy = window.sessionStorage.getItem('thePolicy');
    const province = thePolicy ? JSON.parse(thePolicy).policyProvince : '';
    if (province !== 'Quebec' || (data.lossLocationAddress && data.lossLocationAddress.province !== 'QC' && data.lossLocationAddress.province !== 'Quebec' && data.lossLocationAddress.province !== 'Québec')) {
      return true;
    }
    return false;
  };

  checkedRadioButton = (index, v, name) => {
    const { value } = this.state;
    if (value && value.peopleInTheOtherVehiclesInfo && value.peopleInTheOtherVehiclesInfo[index][name]?.value) {
      if (value.peopleInTheOtherVehiclesInfo[index][name].value === v) { return true; }
    }
    return false;
  };

  addEnterManuallyFields = (index) => {
    const { state: { value }, props: { onChange } } = this;
    const tempState = { ...value };
    if (!this.isABOnly()) {
      if (this.getClaimType() === 'multi_vehicle') {
        tempState.peopleInTheOtherVehiclesInfo[index].insuranceInfo = { ...tempState.peopleInTheOtherVehiclesInfo[index].insuranceInfo, issuingProvince: '', licenseNumber: '' };
      } else {
        tempState.peopleInTheOtherVehiclesInfo[index].license = { issuingProvince: '', licenseNumber: '' };
      }
    } else if (this.isABOnly() && (this.getClaimType() === 'occupantThirdPartyVehicle' || this.getClaimType() === 'injuredPedestrianOrCyclist')) {
      tempState.peopleInTheOtherVehiclesInfo[index].license = { issuingProvince: '', licenseNumber: '' };
    }
    this.setState((prevState) => {
      const tempOpenEnterManuallyForm = { ...prevState.openEnterManuallyForm };
      tempOpenEnterManuallyForm[index] = !tempOpenEnterManuallyForm[index];
      return {
        value: tempState,
        openEnterManuallyForm: tempOpenEnterManuallyForm,
      };
    }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  removeEnterManuallyFields = (index) => {
    const { state: { value }, props: { onChange } } = this;
    const tempState = { ...value };

    if (!this.isABOnly()) {
      delete tempState.peopleInTheOtherVehiclesInfo[index].insuranceInfo?.issuingProvince;
      delete tempState.peopleInTheOtherVehiclesInfo[index].insuranceInfo?.licenseNumber;
    } else {
      delete tempState.peopleInTheOtherVehiclesInfo[index].license;
    }

    this.setState((prevState) => {
      const tempOpenEnterManuallyForm = { ...prevState.openEnterManuallyForm };
      tempOpenEnterManuallyForm[index] = !tempOpenEnterManuallyForm[index];
      return {
        value: tempState,
        openEnterManuallyForm: tempOpenEnterManuallyForm,
      };
    }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  dragAndDropHandler = (index, files) => {
    const { state: { value, formErrors, hasTriggeredError }, props: { onChange } } = this;

    const newList = [...value.peopleInTheOtherVehiclesInfo];
    newList[index].file_TPinfo = files;

    const errors = [...formErrors];
    errors[index].file_TPinfo = !!(hasTriggeredError && newList[index].file_TPinfo.rejectedFiles?.length);

    this.setState({
      value: {
        peopleInTheOtherVehiclesInfo: newList,
        formErrors: errors,
      },
    }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  dynamicLabels = (type) => {
    let label = '';
    const { intl } = this.props;
    const claimType = this.getClaimType();
    if (type === 'section' && (claimType === 'multi_vehicle' || claimType === 'injuredPedestrianOrCyclist')) {
      label = intl.formatMessage({ id: 'Other vehicle', defaultValue: 'Other vehicle' });
    } else if (type === 'section' && claimType === 'collisionWithPedestrian') {
      label = intl.formatMessage({ id: 'Pedestrian', defaultValue: 'Pedestrian' });
    } else if (type === 'section' && claimType === 'collisionWithCyclist') {
      label = intl.formatMessage({ id: 'Cyclist', defaultValue: 'Cyclist' });
    } else if (type === 'section' && claimType === 'occupantThirdPartyVehicle') {
      label = intl.formatMessage({ id: 'Occupied vehicle', defaultValue: 'Occupied vehicle' });
    } else if (type === 'button' && claimType === 'multi_vehicle') {
      label = intl.formatMessage({ id: 'Add a vehicle', defaultValue: 'Add a vehicle' });
    } else if (type === 'button' && claimType === 'collisionWithPedestrian') {
      label = intl.formatMessage({ id: 'Add a pedestrian', defaultValue: 'Add a pedestrian' });
    } else if (type === 'button' && claimType === 'collisionWithCyclist') {
      label = intl.formatMessage({ id: 'Add a cyclist', defaultValue: 'Add a cyclist' });
    } else if (type === 'label' && (claimType === 'multi_vehicle' || this.isABOnly())) {
      label = intl.formatMessage({ id: 'Add other driver\'s information', defaultValue: 'Add other driver\'s information' });
    } else if (type === 'label' && claimType === 'collisionWithPedestrian') {
      label = intl.formatMessage({ id: 'Add information for pedestrian', defaultValue: 'Add information for pedestrian' });
    } else if (type === 'label' && claimType === 'collisionWithCyclist') {
      label = intl.formatMessage({ id: 'Add information for cyclist', defaultValue: 'Add information for cyclist' });
    } else if (type === 'label2' && this.isABOnly()) {
      label = intl.formatMessage({ id: 'Add vehicle information', defaultValue: 'Add vehicle information' });
    } else if (type === 'driversLicense' && (claimType === 'occupantThirdPartyVehicle' || claimType === 'injuredPedestrianOrCyclist' || claimType === 'multi_vehicle')) {
      label = intl.formatMessage({ id: 'Add driver’s license (optional)', defaultValue: 'Add driver’s license (optional)' });
    } else if (type === 'driversLicense' && (claimType === 'collisionWithPedestrian' || claimType === 'collisionWithCyclist')) {
      label = intl.formatMessage({ id: 'Upload files or images (optional)', defaultValue: 'Upload files or images (optional)' });
    }
    return label;
  };

  addNewElement = () => {
    const { props: { onChange }, state: { formErrors } } = this;
    const errors = formErrors?.length ? [...formErrors] : [];
    const newObject = { temporaryId: `tempId-${v4()}`, id: '', vehicleIncidentTempId: `vehicle-incident-tempId-${v4()}`, vehicleIncidentId: '', injuryIncidentTemporaryId: `injury-incident-tempId-${v4()}`, injuryIncidentId: '', firstName: { value: '', review: { label: this.getNameReviewLabel(), defaultValue: 'Unknown' } }, lastName: { value: '', review: { label: this.getNameReviewLabel() } }, number: { value: '', review: { label: 'Contact', defaultValue: 'Unknown' } }, file_TPinfo: {} };
    if (this.getClaimType() === 'multi_vehicle' && !this.isABOnly()) {
      newObject.peopleInTpVehicle = { value: '', review: { label: 'Number of passengers', defaultValue: 'Unknown', typelist: getTypelist('peopleInTpVehicle', this.getClaimType()) } };
      newObject.insuranceInfo = { insurer: '', policyNumber: '' };
    }
    if (this.checkIfProvinceQuebec() && !this.isABOnly()) {
      newObject.applyThirdParty = { value: '', review: { label: 'Injuries', typelist: getTypelist('applyThirdParty', this.getClaimType()) } };
    }
    errors.push({ applyThirdParty: false, number: false, file_TPinfo: false });
    this.setState((prevState) => ({
      value: { peopleInTheOtherVehiclesInfo: [...prevState.value.peopleInTheOtherVehiclesInfo, newObject] },
      openEnterManuallyForm: {
        ...prevState.openEnterManuallyForm,
        [prevState.value.peopleInTheOtherVehiclesInfo.length]: false,
      },
      formErrors: errors,
    }), () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  isABOnly = () => {
    if (this.getClaimType() === 'occupantThirdPartyVehicle' || this.getClaimType() === 'injuredPedestrianOrCyclist') {
      return true;
    }
    return false;
  };

  removeNewElement = (index) => {
    const { state: { value, formErrors }, props: { onChange } } = this;
    const tempState = { ...value };
    const errors = formErrors?.length ? [...formErrors] : [];
    const updatedState = tempState.peopleInTheOtherVehiclesInfo.filter((_, i) => i !== index);
    const newErrors = errors.filter((_, i) => i !== index);
    this.setState((prevState) => {
      const tempOpenEnterManuallyForm = { ...prevState.openEnterManuallyForm };
      delete tempOpenEnterManuallyForm[index];
      const readjustIndexes = {};
      Object.keys(tempOpenEnterManuallyForm).forEach((key) => {
        if (key > index) {
          readjustIndexes[key - 1] = tempOpenEnterManuallyForm[key];
        } else {
          readjustIndexes[key] = tempOpenEnterManuallyForm[key];
        }
      });
      return {
        value: {
          peopleInTheOtherVehiclesInfo: updatedState,
        },
        formErrors: newErrors,
        openEnterManuallyForm: readjustIndexes,
      };
    }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  isPhoneNumberValid = (number) => {
    if (number[1] === '1') {
      this.state.errorPhoneNumberStart1 = true;
      return false;
    }
    this.state.errorPhoneNumberStart1 = false;
    return (number.length === 0 || number.length === 14);
  };

  render() {
    const { state: { value, data, formErrors, errorPhoneNumberStart1, openEnterManuallyForm, fatalityModal }, props: { component: { maxFiles, filePattern, typeOfFiles, fileMinimumSize, fileMaximumSize, globalErrorMessage, maxFilesErrorMessage, maxFilesModalErrorMessage }, disabled, intl, localParams } } = this;
    return (
      <div className="peopleInTheOtherVehicles">
        {((data?.collectDriversInformation?.value) || (data?.driversInformation?.value)) && value?.peopleInTheOtherVehiclesInfo?.length ? value.peopleInTheOtherVehiclesInfo.map((element, index) => (
          <div key={`section_${index}_${value?.peopleInTheOtherVehiclesInfo?.length}`} className="section">
            <Grid key={index}>
              <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center' }}>
                <h3 className="other-vehicle-label">{this.dynamicLabels('section')} {this.getClaimType() !== 'occupantThirdPartyVehicle' && this.getClaimType() !== 'injuredPedestrianOrCyclist' ? index + 1 : ''}</h3>
                {index > 0 ? (
                  <button
                    type="button"
                    className="removeNewElementButton"
                    onClick={() => this.removeNewElement(index)}
                  >
                    <FormattedMessage id="Remove" defaultMessage="Remove" />
                  </button>
                ) : null}
              </div>
              <label className="question-margin-xsmall label-question">{this.dynamicLabels('label')} {this.getClaimType() !== 'occupantThirdPartyVehicle' && this.getClaimType() !== 'injuredPedestrianOrCyclist' ? index + 1 : ''} {intl.formatMessage({ id: '(optional)', defaultValue: '(optional)' })}</label>
              <Grid.Row>
                <Grid.Column colMd6 colSm12>
                  <TextInput
                    disabled={disabled}
                    className="question-margin-xsmall fs-exclude"
                    name="firstName"
                    placeholder={intl.formatMessage({ id: 'First name', defaultValue: 'First name' })}
                    defaultValue={element.firstName?.value || ''}
                    onChange={(v) => this.handleChange(v, index, 'firstName')}
                    maxLength={60}
                  />
                </Grid.Column>
                <Grid.Column colMd6 colSm12>
                  <TextInput
                    disabled={disabled}
                    className="question-margin-xsmall fs-exclude"
                    name="lastName"
                    placeholder={intl.formatMessage({ id: 'Last name', defaultValue: 'Last name' })}
                    defaultValue={element.lastName?.value || ''}
                    onChange={(v) => this.handleChange(v, index, 'lastName')}
                    maxLength={60}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd6 colSm12>
                  <TextInput
                    disabled={disabled}
                    className="question-margin-xsmall fs-exclude"
                    name="number"
                    mask="(999) 999-9999"
                    placeholder={intl.formatMessage({ id: 'Phone number', defaultValue: 'Phone number' })}
                    defaultValue={element.number?.value || ''}
                    onChange={(v) => this.handleChange(v, index, 'number')}
                    maxLength={30}
                  />
                  {formErrors && formErrors[index] && formErrors[index].number && (
                    errorPhoneNumberStart1 ? (
                      <div className="formio-errors invalid-feedback">
                        <div className="form-text error"><FormattedMessage id="Oops! An area code cannot start with 1." defaultMessage="Oops! An area code cannot start with 1." /></div>
                      </div>
                    ) : (
                      <div className="formio-errors invalid-feedback">
                        <div className="form-text error"><FormattedMessage id="Sorry! Your phone number must be 10 digits." defaultMessage="Sorry! Your phone number must be 10 digits." /></div>
                      </div>
                    )
                  )}
                </Grid.Column>
                <Grid.Column colMd6 colSm12>
                  <AutocompleteDMTI
                    showErrorHandling
                    index={index}
                    localParams={localParams}
                    disabled={disabled}
                    name="address"
                    placeholder={intl.formatMessage({ id: 'Address', defaultValue: 'Address' })}
                    value={element.address?.value && element.address?.addressObj ? { value: element.address.value, addressObj: element.address.addressObj } : { value: '', addressObj: {} }}
                    handleChange={this.handleChange}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd6 colSm12>
                  {this.getClaimType() === 'multi_vehicle' && !this.isABOnly() ? (
                    <div className="question-margin-xsmall">
                      <Autocomplete
                        index={index}
                        disabled={disabled}
                        name="insurer"
                        placeholder={intl.formatMessage({ id: 'Insurance company', defaultValue: 'Insurance company' })}
                        value={element.insuranceInfo?.insurer || ''}
                        suggestionsArray={insurerArray}
                        handleChange={this.handleChange}
                      />
                    </div>
                  ) : null}
                </Grid.Column>
                <Grid.Column colMd6 colSm12>
                  {this.getClaimType() === 'multi_vehicle' && !this.isABOnly() ? (
                    <div>
                      <TextInput
                        disabled={disabled}
                        className="question-margin-xsmall fs-exclude"
                        name="policyNumber"
                        placeholder={intl.formatMessage({ id: 'Policy number', defaultValue: 'Policy number' })}
                        defaultValue={element.insuranceInfo?.policyNumber || ''}
                        onChange={(v) => this.handleChange(v, index, 'policyNumber')}
                        maxLength={30}
                      />
                    </div>
                  ) : null}
                </Grid.Column>
              </Grid.Row>
              <div className="question-margin-label" style={{ display: 'flex', flexDirection: 'row' }}>
                <label className="label-question" style={{ marginBottom: 0 }}>{this.dynamicLabels('driversLicense')}</label>
                <Tooltip id="uploadfiles_tooltip" title={intl.formatMessage({ id: 'Uploading files', defaultValue: 'Uploading files' })} primary>
                  <FormattedMessage
                    {...messages.tooltip}
                    values={{
                      videoAudioImageAndTextDocuments: (
                        <a href={intl.formatMessage(messages.videoAudioImageAndTextDocumentsUrl)} target="_blank" rel="noreferrer">
                          {intl.formatMessage(messages.videoAudioImageAndTextDocuments)}
                        </a>
                      ),
                    }}
                  />
                </Tooltip>
              </div>
              <div className="file-upload-margin margin-question-upload">
                <FormioErrorHandler>
                  <FileUpload
                    index={index}
                    style={{ marginLeft: '10px', marginRight: '10px' }}
                    dragAndDrop={this.dragAndDropHandler}
                    value={element.file_TPinfo}
                    maxFiles={maxFiles}
                    filePattern={filePattern}
                    typeOfFiles={typeOfFiles}
                    fileMinimumSize={fileMinimumSize}
                    fileMaximumSize={fileMaximumSize}
                    globalErrorMessage={globalErrorMessage}
                    maxFilesModalErrorMessage={maxFilesModalErrorMessage}
                    maxFilesErrorMessage={maxFilesErrorMessage}
                    localParams={localParams}
                  />
                </FormioErrorHandler>
              </div>
              {formErrors && formErrors[index] && formErrors[index].file_TPinfo ? (
                <div className="formio-errors invalid-feedback" />
              ) : null}
              {!openEnterManuallyForm[index] ? (
              // <Grid.Row mb4>
                <button
                  type="button"
                  className="enterManuallyButton question-margin-label"
                  style={{ marginTop: '16px' }}
                  onClick={() => this.addEnterManuallyFields(index)}
                ><FormattedMessage id="Enter manually" defaultMessage="Enter manually" />
                </button>
              // </Grid.Row>
              ) : null}
              {openEnterManuallyForm[index] ? (
                <>
                  <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', marginTop: '16px' }} className="question-margin-xsmall">
                    <p className="enterManuallyTitle"><FormattedMessage id="Enter info manually" defaultMessage="Enter info manually" /></p>
                    <button
                      type="button"
                      className="removeEnterManuallyButton"
                      onClick={() => this.removeEnterManuallyFields(index)}
                    >
                      <FormattedMessage id="Remove" defaultMessage="Remove" />
                    </button>
                  </div>
                  <Grid.Row>
                    <Grid.Column colMd6 colSm12>
                      {this.getClaimType() === 'multi_vehicle' && !this.isABOnly() ? (
                        <div>
                          <Dropdown
                            className="question-margin-xsmall fs-exclude"
                            primary
                            options={issuingProvince}
                            placeholder={intl.formatMessage({ id: 'Issuing province', defaultValue: 'Issuing province' })}
                            value={element.insuranceInfo?.issuingProvince || ''}
                            onChange={(v) => this.handleChange(v, index, 'issuingProvince')}
                            disabled={disabled}
                          />
                        </div>
                      ) : (
                        <div>
                          <Dropdown
                            className="question-margin-xsmall fs-exclude"
                            primary
                            options={issuingProvince}
                            placeholder={intl.formatMessage({ id: 'Issuing province', defaultValue: 'Issuing province' })}
                            value={element.license?.issuingProvince || ''}
                            onChange={(v) => this.handleChange(v, index, 'issuingProvince')}
                            disabled={disabled}
                          />
                        </div>
                      )}
                    </Grid.Column>
                    <Grid.Column colMd6 colSm12>
                      {this.getClaimType() === 'multi_vehicle' && !this.isABOnly() ? (
                        <div>
                          <TextInput
                            className="question-margin-xsmall fs-exclude"
                            disabled={disabled}
                            name="licenseNumber"
                            placeholder={intl.formatMessage({ id: "Driver's license number", defaultValue: "Driver's license number" })}
                            defaultValue={element.insuranceInfo?.licenseNumber || ''}
                            onChange={(v) => this.handleChange(v, index, 'licenseNumber')}
                            maxLength={20}
                          />
                        </div>
                      ) : (
                        <div>
                          <TextInput
                            className="question-margin-xsmall fs-exclude"
                            disabled={disabled}
                            name="licenseNumber"
                            placeholder={intl.formatMessage({ id: "Driver's license number", defaultValue: "Driver's license number" })}
                            defaultValue={element.license?.licenseNumber || ''}
                            onChange={(v) => this.handleChange(v, index, 'licenseNumber')}
                            maxLength={20}
                          />
                        </div>
                      )}
                    </Grid.Column>
                  </Grid.Row>
                </>
              ) : null}
              {/* </Grid.Row> */}
              {this.getClaimType() === 'multi_vehicle' && !this.isABOnly() ? (
                <div>
                  <label className="label-question question-margin-label"><FormattedMessage id="How many people were in the other vehicle? (optional)" defaultMessage="How many people were in the other vehicle? (optional)" /></label>
                  {peopleInTpVehicleOptions.map((radioIndex) => (
                    <RadioButton
                      secondary
                      disabled={disabled}
                      id={`peopleInTpVehicleOptions_${Math.random() * 0xffffffffffff}`}
                      key={`key_peopleInTpVehicleOptions_${Math.random() * 0xffffffffffff}`}
                      value={radioIndex.value}
                      onChange={(v) => this.handleChange(v, index, 'peopleInTpVehicle')}
                      checked={this.checkedRadioButton(index, radioIndex.value, 'peopleInTpVehicle')}
                    >
                      <FormattedMessage id={radioIndex.label} defaultMessage={radioIndex.label} />
                    </RadioButton>
                  ))}
                </div>
              ) : null}
              {this.checkIfProvinceQuebec() && !this.isABOnly() ? (
                <>
                  <label className="label-question question-margin-label"><FormattedMessage id="Select the option that applies for the other people involved in the incident." defaultMessage="Select the option that applies for the other people involved in the incident." /></label>
                  {applyThirdPartyOptions.map((radioIndex) => (
                    <RadioButton
                      secondary
                      disabled={disabled}
                      id={`applyThirdPartyOptions_${Math.random() * 0xffffffffffff}`}
                      key={`key_applyThirdPartyOptions_${Math.random() * 0xffffffffffff}`}
                      value={radioIndex.value}
                      onChange={(v) => this.handleChange(v, index, 'applyThirdParty')}
                      checked={this.checkedRadioButton(index, radioIndex.value, 'applyThirdParty')}
                    >
                      <FormattedMessage id={radioIndex.label} defaultMessage={radioIndex.label} />
                    </RadioButton>
                  ))}
                  {formErrors && formErrors[index] && formErrors[index].applyThirdParty && (
                  <div className="formio-errors invalid-feedback">
                    <div className="form-text error"><FormattedMessage id="Oops! Looks like you forgot to fill this in." defaultMessage="Oops! Looks like you forgot to fill this in." /></div>
                  </div>
                  )}
                </>
              ) : null}
              {this.isABOnly() ? (
                <div>
                  <label>{this.dynamicLabels('label2')}</label>
                </div>
              ) : null}
              <Grid.Row>
                <Grid.Column colMd6 colSm12>
                  {this.isABOnly()
                    ? this.getClaimType() === 'injuredPedestrianOrCyclist' ? (
                      <div className="question-margin-xsmall fs-exclude">
                        <Autocomplete
                          index={index}
                          disabled={disabled}
                          name="insurer"
                          placeholder={intl.formatMessage({ id: 'Insurance company', defaultValue: 'Insurance company' })}
                          value={element.vehicle.insurer || ''}
                          suggestionsArray={insurerArray}
                          handleChange={this.handleChange}
                        />
                      </div>
                    ) : (
                      <div className="question-margin-xsmall fs-exclude">
                        <Autocomplete
                          index={index}
                          disabled={disabled}
                          name="insurer"
                          placeholder={intl.formatMessage({ id: 'Insurance company', defaultValue: 'Insurance company' })}
                          value={element.insuranceInfo.insurer || ''}
                          suggestionsArray={insurerArray}
                          handleChange={this.handleChange}
                        />
                      </div>
                    ) : null}
                </Grid.Column>
                <Grid.Column colMd6 colSm12>
                  {this.isABOnly()
                    ? this.getClaimType() === 'injuredPedestrianOrCyclist' ? (
                      <div>
                        <TextInput
                          className="question-margin-xsmall fs-exclude"
                          disabled={disabled}
                          name="policyNumber"
                          placeholder={intl.formatMessage({ id: 'Policy number', defaultValue: 'Policy number' })}
                          defaultValue={element.vehicle.policyNumber || ''}
                          onChange={(v) => this.handleChange(v, index, 'policyNumber')}
                          maxLength={30}
                        />
                      </div>
                    ) : (
                      <div>
                        <TextInput
                          className="question-margin-xsmall fs-exclude"
                          disabled={disabled}
                          name="policyNumber"
                          placeholder={intl.formatMessage({ id: 'Policy number', defaultValue: 'Policy number' })}
                          defaultValue={element.insuranceInfo.policyNumber || ''}
                          onChange={(v) => this.handleChange(v, index, 'policyNumber')}
                          maxLength={30}
                        />
                      </div>
                    ) : null}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd6 colSm12>
                  {this.isABOnly() && this.getClaimType() === 'injuredPedestrianOrCyclist' ? (
                    <div>
                      <TextInput
                        className="question-margin-xsmall fs-exclude"
                        disabled={disabled}
                        name="make"
                        placeholder={intl.formatMessage({ id: 'Vehicle make', defaultValue: 'Vehicle make' })}
                        defaultValue={element.vehicle.make || ''}
                        onChange={(v) => this.handleChange(v, index, 'make')}
                      />
                    </div>
                  ) : null}
                </Grid.Column>
                <Grid.Column colMd6 colSm12>
                  {this.isABOnly() && this.getClaimType() === 'injuredPedestrianOrCyclist' ? (
                    <div>
                      <TextInput
                        className="question-margin-xsmall fs-exclude"
                        disabled={disabled}
                        name="model"
                        placeholder={intl.formatMessage({ id: 'Vehicle model', defaultValue: 'Vehicle model' })}
                        defaultValue={element.vehicle.model || ''}
                        onChange={(v) => this.handleChange(v, index, 'model')}
                      />
                    </div>
                  ) : null}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column colMd6 colSm12>
                  {this.isABOnly() && this.getClaimType() === 'injuredPedestrianOrCyclist' ? (
                    <div>
                      <TextInput
                        className="question-margin-xsmall fs-exclude"
                        disabled={disabled}
                        name="year"
                        number
                        placeholder={intl.formatMessage({ id: 'Vehicle year', defaultValue: 'Vehicle year' })}
                        defaultValue={element.vehicle.year || ''}
                        onChange={(v) => this.handleChange(v, index, 'year')}
                      />
                    </div>
                  ) : null}
                </Grid.Column>
              </Grid.Row>
              {!this.isABOnly() && index + 1 === value?.peopleInTheOtherVehiclesInfo?.length ? (
                <div>
                  <button
                    type="button"
                    className="addNewElementButton"
                    onClick={() => this.addNewElement()}
                  >{this.dynamicLabels('button')}
                  </button>
                </div>
              ) : null}
            </Grid>
          </div>
        )) : null}
        {fatalityModal.num === 1 && !fatalityModal.opened && (
          <FatalityPopUp
            open={!fatalityModal.opened}
            closeFatalityPopUp={() => this.setState({ fatalityModal: { opened: true, num: 1 } })}
          />
        )}
      </div>
    );
  }
};
const CustomPeopleInTheOtherVehiclesWithIntl = injectIntl(CustomPeopleInTheOtherVehicles);
export default class PeopleInTheOtherVehiclesComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom PeopleInTheOtherVehicles',
      icon: 'tasks',
      group: 'data',
      documentation: '',
      schema: PeopleInTheOtherVehiclesComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customPeopleInTheOtherVehicles',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomPeopleInTheOtherVehiclesSettings;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomPeopleInTheOtherVehiclesWithIntl
          inputRef={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          data={this.data}
          form={this.root?.parent}
          onChange={this.updateValue}
          localParams={localParams}
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
